import { Button, Card, CardHeader, SegmentedTabs } from "@helmr/ui";
import { Link, useSearchParams } from "react-router-dom";
import { AdvancesTab } from "./AdvancesTab";
import { commissionAllows } from "./CommissionPage";
import { PageHead, css as s, monthLabel, monthOf, shiftMonth, useScope } from "./kit";
import { ProfilesTab } from "./ProfilesTab";

type Tab = "month" | "profiles" | "advances";

/** `/payroll`: Month | Profiles | Advances. */
export function PayrollPage() {
  const [params, setParams] = useSearchParams();
  const sc = useScope();
  const raw = params.get("tab");
  const tab: Tab = raw === "profiles" || raw === "advances" ? raw : "month";
  const here = monthOf(sc.today);
  const months = [shiftMonth(here, 1), here, shiftMonth(here, -1), shiftMonth(here, -2)];
  return (
    <div className={s.page}>
      <PageHead title="Payroll" sub="Close the month: draft, approve, lock.">
        {commissionAllows(sc.ctx.has) ? <Button as={Link} to="/payroll/commission" size="sm">Commission</Button> : null}
        <SegmentedTabs label="Payroll sections" value={tab} onChange={(v) => setParams(v === "month" ? {} : { tab: v })} options={[{ value: "month", label: "Month" }, { value: "profiles", label: "Profiles" }, { value: "advances", label: "Advances" }]} />
      </PageHead>
      {tab === "month" ? (
        <Card aria-label="Payroll months">
          <CardHeader title="Months" subtitle="Open a month to build its draft or see its payslips." />
          <ul className={s.list}>
            {months.map((m) => <li key={m}><span>{monthLabel(m, sc.locale)}</span><Link to={`/payroll/${m}`}>Open</Link></li>)}
          </ul>
        </Card>
      ) : tab === "profiles" ? <ProfilesTab /> : <AdvancesTab />}
    </div>
  );
}
